const DefaultColumn = ({ children }) => {
    return (
        <p className="text-sm text-textDefault">{children}</p>   
    );
};
  
export default DefaultColumn;
